module.exports = __webpack_public_path__ + "img/img-ffp-west.ac7ce9ca.jpg";